<div class="flex flex-col w-full h-full p-6 gap-6 bg-surface-50 overflow-auto">
  @if (taLoaded()) {
    <manage-ta-container></manage-ta-container>

    <p-selectbutton
      [options]="showDetailsOptions"
      [(ngModel)]="showDetailsState"
      [unselectable]="true"
    >
      <ng-template let-item pTemplate="item">
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </ng-template>
    </p-selectbutton>

    @if (showDetailsState === 'showDetails') {
      <view-ta [edit]="taSubmission()?.status === 'PendingAcquittal' || permissionService.canEditTaAfterApproval() || (taSubmission()?.status === 'PendingApproval' && permissionService.canEditTaBeforeApproval())"
               (dialogClosed)="editDialogClosed()"></view-ta>
    } @else if (showDetailsState === 'hideDetails') {}
  }
</div>
